

// ppa
Vue.component('quote-create', require('./Quotes/vue/quote-create.vue').default);
Vue.component('quote-detail', require('./Quotes/vue/quote-detail.vue').default);
Vue.component('quote-list', require('./Quotes/vue/quote-list.vue').default);
Vue.component('quote-list-employer-detail', require('./Quotes/vue/quote-list-employer-detail.vue').default);
Vue.component('ppa-quote-page', require('./Quotes/vue/ppa-quote-page.vue').default);
Vue.component('ppa-quote', require('./Quotes/vue/ppa-quote.vue').default);

Vue.component('proposal-detail', require('./Proposals/vue/proposal-detail.vue').default);
Vue.component('proposal-list', require('./Proposals/vue/proposal-list.vue').default);
Vue.component('proposal-list-employer-detail', require('./Proposals/vue/proposal-list-employer-detail.vue').default);
Vue.component('proposal-form', require('./Proposals/vue/signature/proposal-form.vue').default);
Vue.component('proposal-form2', require('./ProposalsPresentation/vue/proposal-form2.vue').default);

// proposal2
Vue.component('proposal-detail2', require('./Proposals2/vue/proposal-detail.vue').default);
Vue.component('proposal-list2', require('./Proposals2/vue/proposal-list.vue').default);
Vue.component('proposal-list-employer-detail2', require('./Proposals2/vue/proposal-list-employer-detail.vue').default);
Vue.component('proposal-presentation', require('./ProposalsPresentation2/vue/proposal-presentation.vue').default);

// proposal3
Vue.component('proposal-detail3', require('./Proposals3/vue/proposal-detail.vue').default);
Vue.component('proposal-list3', require('./Proposals3/vue/proposal-list.vue').default);
Vue.component('proposal-list-employer-detail3', require('./Proposals3/vue/proposal-list-employer-detail.vue').default);
Vue.component('proposal-presentation3', require('./ProposalsPresentation3/vue/proposal-presentation.vue').default);

Vue.component('prospect-list', require('./Prospects/vue/prospect-list.vue').default);
Vue.component('prospect-detail', require('./Prospects/vue/prospect-detail.vue').default);

Vue.component('prospect-usdots', require('./ProspectScraperUsdot/vue/prospect-usdots.vue').default);

Vue.component('magic-link-button', require('./Api/vue/magic-link-button.vue').default);